import { Button, FormControl, Typography } from "@mui/material";
import Grid from '@mui/material/Grid2';
import axios from "axios";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { postToEndpoint } from "../AxiosHelper";

export type VerifyPageProps = {
    token: string | undefined;
    requestLogout: () => void;
}

function VerifyPage(props: VerifyPageProps): JSX.Element {
    const navigate = useNavigate();
    const { token, requestLogout } = props;
    const location = useLocation();
    const userRegistration = new URLSearchParams(location.search).get('userRegistration');
    const [result, setResult] = useState<string>('');
    const [isError, setIsError] = useState<boolean>(false);

    useEffect(() => {
        if (token !== undefined) {
            requestLogout();
        }
    }, [requestLogout, token]);

    useEffect(() => {
        if (userRegistration !== null && token === undefined) {
            postToEndpoint('verify', { userRegistration: userRegistration })
                .then(() => { setResult(t('user.verify.success')); })
                .catch((error) => {
                    const response = error.response;
                    let errorLabel = 'user.verify.fail.general_error';
                    if (axios.isAxiosError(error)) {
                        if (response?.status === 404) {
                            errorLabel = 'user.verify.fail.not_valid';
                        }
                    }
                    setResult(t(errorLabel));
                    setIsError(true);
                });
        } else {
            setResult(t('user.verify.fail.general_error'));
        }
    }, [token, userRegistration]);

    return <FormControl>
        <Grid container>
            <Grid>
                <Typography color={isError ? "error" : "primary"}>
                    {result}
                </Typography>
            </Grid>
            <Grid style={{ width: '100%' }}>
                <Button variant="contained" color="primary" onClick={() => navigate('/login')} fullWidth>
                    {t('user.verify.btn')}
                </Button>
            </Grid>
        </Grid>
    </FormControl>
}

export default VerifyPage;
